"use client";
import { jsx as i } from "react/jsx-runtime";
import { css as a } from "@emotion/react";
import e from "@emotion/styled";
import { COLORS as f } from "../../tokens/colors/Colors.js";
import { FONT_SIZES as T } from "../../tokens/font-sizes/FontSizes.js";
import { FONT_WEIGHTS as c } from "../../tokens/font-weights/FontWeights.js";
import { LINE_HEIGHTS as x } from "../../tokens/line-heights/LineHeights.js";
import { forwardRef as d } from "react";
const s = d(
  ({ as: m = "p", children: t, ...o }, r) => /* @__PURE__ */ i(l, { ...o, as: m, "data-comp": "text", ref: r, children: t })
);
s.displayName = "Text";
const _ = s, l = e.span(
  ({ as: m, feColor: t, feFontSize: o, feFontWeight: r, feLineHeight: p }) => a`
		color: ${t && f[t]};
		font-size: ${o && T[o]};
		font-weight: ${r && c[r]};
		line-height: ${p && x[p]};
		margin: ${m === "p" && 0};
	`
);
export {
  _ as default
};
